if (!customElements.get('option-popup')) {
  class OptionPopup extends HTMLElement {
    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
    }

    handleToggle(event) {
      if (event.detail.target != `#${this.id}`) return;

      this.classList.toggle('is-open');
      document.body.classList.toggle('overflow-hidden', this.classList.contains('is-open'));
    }

    disconnectedCallback() {
      document.removeEventListener('rocket:popup-toggle', this.handleToggleRef);
    }

    connectedCallback() {
      document.addEventListener('rocket:popup-toggle', this.handleToggleRef);
    }
  }

  customElements.define('option-popup', OptionPopup);
}
